import AuthenticationAPI from 'api/authentication';
import UserUtils from './user-utils';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_UPDATE = 'USER_UPDATE';

export const userLogin = data => {
    const requestData = {
        ...data,
        includes: UserUtils.INCLUDES
    };

    return {
        type: USER_LOGIN,
        payload: AuthenticationAPI.login(requestData)
    };
};

export const userLogout = () => {
    return {
        type: USER_LOGOUT,
        payload: AuthenticationAPI.logout()
    };
};

export const userUpdate = data => {
    return {
        type: USER_UPDATE,
        payload: data
    };
};
